module.exports = __webpack_public_path__ + "a777c2ffd20ef7f17543ae295ad9de8a.png";